import React from 'react'
import { Link } from 'react-router-dom'
import { IonImg } from '@ionic/react'
import './styles.scss'

const ProductSquaredCard = (props) => {
  const { product, flexible } = props
  return (
    <figure className={`product-squared-card${flexible ? ' flexible' : ''}`}>
      <Link
        to={`/podcast/${product.id}_${product.url_name}`}
        aria-label={`Ver todos los episodios de ${product.product}`}
      >
        <IonImg
          src={product.image_card}
          alt={`Portada de ${product.product}`}
        />
      </Link>
    </figure>
  )
}

export default ProductSquaredCard
